<template>
  <div class="components-container">
    <div
      class="upload-item sort-move"
      v-for="(item, index) in fileList"
      :key="index"
    >
      <div
        v-if="item.fileType == 2"
        class="del-file"
        style="right: 30px"
        @click.stop="handleVideoPlayOrMove"
      >
        <i :class="!isVideoMove ? 'el-icon-thumb' : 'el-icon-video-play'"></i>
      </div>
      <div class="del-file" @click.stop="handleDeleteFile(index)">
        <i class="el-icon-delete"></i>
      </div>
      <div
        class="move-wrap"
        @dragstart="handleDragStart(index)"
        @dragenter="handleDragEnter(index, $event)"
        @dragend="handleDragEnd(index, $event)"
        @dragover="handleDragOver($event)"
      >
        <el-image
          v-if="item.fileType == 1"
          :src="item.showImageUrl"
          class="file-content"
        ></el-image>
        <video
          :controls="!isVideoMove"
          v-if="item.fileType == 2 && !isVideoMove"
          :src="item.eventImageUrl"
          :poster="item.showEventImageThumbnailUrl"
          class="file-content"
        ></video>
        <el-image
          v-if="item.fileType == 2 && isVideoMove"
          :src="item.showEventImageThumbnailUrl"
          class="file-content"
        ></el-image>
      </div>
    </div>
    <div
      class="upload-item add-upload-item sort-move"
      v-if="fileList.length < 5"
      @click="handleShowAddFileModel"
    >
      <div class="move-wrap">
        <i class="el-icon-plus add-icon"></i>
      </div>
    </div>
    <addFileModel
      :allowAddVideo="allowAddVideo"
      :isShowAddModel="isShowAddModel"
      :newSortOder="maxSortOrder"
      @addFile="handleAddFile"
      @close="handleCloseAddModel"
    ></addFileModel>
  </div>     
</template>
<script>
import addFileModel from "./addFileModel";
export default {
  name: "upload-video-or-picture",
  components: { addFileModel },
  data() {
    return {
      fileList: [],
      draggingIndex: null,
      beDraggedIndex: null,
      isShowAddModel: false,
      isVideoMove: false,
    };
  },
  props: {
    inputFileList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    inputFileList: {
      handler: function (e) {
        if (!this.$lodash.isEqual(this.fileList, e))
          this.fileList = this.$lodash.cloneDeep(e);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    allowAddVideo() {
      return !this.fileList.find((i) => {
        return i.fileType == 2;
      });
    },
    maxSortOrder() {
      return this.$lodash.maxBy(this.fileList, (i) => {
        return i.sortOrder;
      });
    },
  },
  methods: {
    handleDragStart(index) {
      this.draggingIndex = index;
    },
    handleDragEnter(index, e) {
      this.beDraggedIndex = index;
      e.preventDefault();
    },
    handleDragEnd(index, e) {
      const newList = [...this.fileList];
      const draggingItem = this.fileList[this.draggingIndex];
      const beDraggedItem = this.fileList[this.beDraggedIndex];

      const beDraggedSortOrder = beDraggedItem.sortOrder;
      const draggingSortOrder = draggingItem.sortOrder;

      draggingItem.sortOrder = beDraggedSortOrder;
      beDraggedItem.sortOrder = draggingSortOrder;

      newList.splice(this.draggingIndex, 1);
      newList.splice(this.beDraggedIndex, 0, draggingItem);

      this.fileList = newList;
      this.$emit("changeList", newList);

      this.draggingIndex = null;
      this.beDraggedIndex = null;
    },
    handleDragOver(e) {
      e.preventDefault();
    },
    handleShowAddFileModel() {
      this.isShowAddModel = true;
    },
    handleCloseAddModel() {
      this.isShowAddModel = false;
    },
    handleAddFile(e) {
      this.fileList.push(e);
      this.$emit("changeList", this.fileList);
    },
    handleDeleteFile(index) {
      const newList = [...this.fileList];
      newList.splice(index, 1);
      this.fileList = newList;
      this.$emit("changeList", newList);
    },
    handleVideoPlayOrMove() {
      this.isVideoMove = !this.isVideoMove;
    },
  },
  mounted() {},
  created() {},
};
</script>
<style lang="scss" scoped>
.components-container {
  display: flex;
  flex-wrap: wrap;
  .upload-item {
    position: relative;
    border: 1px soild #c0ccda;
    color: #8c939d;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
    .move-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      .file-content {
        width: 100%;
      }
      .sort-move {
        transition: transform 0.8s;
      }
      .add-icon {
        font-size: 28px;
        line-height: 148px;
        text-align: center;
        width: 100%;
      }
    }
    .del-file {
      position: absolute;
      top: 0px;
      right: 10px;
      font-size: 15px;
      color: #8c939d;
      display: none;
      z-index: 10;
    }
  }

  .upload-item:hover {
    .del-file {
      display: block;
    }
  }

  .add-upload-item {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
  }
  .upload-item:hover {
    color: #409eff;
    border-color: #409eff;
  }
}
</style>
